import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { INamingTemplatePart, INamingTemplateData, INamingTemplatePutData } from './interfaces';

const basePathMetatags = 'metaTags';
const basePath = '/namingTemplates';

/* eslint-disable implicit-arrow-linebreak */

export const getNamingTemplateParts = (): AxiosPromise<IApiResponse<Array<INamingTemplatePart>>> =>
  vaultApi.getInstance().post(`${basePathMetatags}/namingTemplateParts`);

export const getNamingTemplates = (): AxiosPromise<IApiResponse<INamingTemplateData>> =>
  vaultApi.getInstance().get(`${basePath}/orgDefault`);

export const updateNamingTemplates = (id: string, namingTemplateData: INamingTemplatePutData): AxiosPromise<any> =>
  vaultApi.getInstance().put(`${basePath}/${id}`, namingTemplateData);

export const getAssetTemplateName = (id: string, assetId: string): AxiosPromise<IApiResponse<string>> =>
  vaultApi.getInstance().get(`${basePath}/${id}/asset/${assetId}`);

export const getAssetDefaultName = (assetId: string): AxiosPromise<IApiResponse<string>> =>
  vaultApi.getInstance().get(`${basePath}/asset/${assetId}`);
